export { GUEST_PROFILE_GUID } from '@intigral/constant';

export const GUEST_CLIENT = 'WEB';

export const GUEST_ALLOWED_PRIMARY_SEGMENTS = new Set<string>([
    'play',
    'search',
    'catchup-player',
    'consent-management',
    'parental-pin-management',
]);

export const GUEST_CAROUSEL_TYPE_EXEMPTIONS = new Set<string>(['SEARCH_RESULTS']);

const AUTH_TOKEN_FIELD_NAMES = [
    'authToken',
    'userLoginToken',
    'token',
    'access_token',
    'userToken',
    'auth_token',
    'wmToken',
    'refreshToken',
    'bearerToken',
    'accessToken',
] as const;

export const GUEST_LOGIN_TOKEN_FIELDS = AUTH_TOKEN_FIELD_NAMES;
